import type { NavigateFunction } from 'react-router-dom';

export const HOME_SECTION_IDS = ['home', 'calculator', 'how-it-works', 'download', 'faq', 'where-we-send'] as const;
export type HomeSectionId = (typeof HOME_SECTION_IDS)[number];

export function isHomeSectionId(id: string): id is HomeSectionId {
  return (HOME_SECTION_IDS as readonly string[]).includes(id);
}

export function shouldScrollInPlace(pathname: string, elementExists: boolean): boolean {
  return pathname === '/' && elementExists;
}

export function homeHashAction(hash: string): 'section' | 'top' {
  const id = hash.startsWith('#') ? decodeURIComponent(hash.slice(1)) : '';
  return isHomeSectionId(id) ? 'section' : 'top';
}

export function goToSection(
  id: HomeSectionId,
  pathname: string,
  navigate: NavigateFunction,
): void {
  const el = document.getElementById(id);
  if (el != null && shouldScrollInPlace(pathname, true)) {
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    return;
  }
  navigate({ pathname: '/', hash: `#${id}` });
}

export function scrollLegalHash(hash: string): void {
  const id = hash.startsWith('#') ? decodeURIComponent(hash.slice(1)) : '';
  const el = id ? document.getElementById(id) : null;
  if (el) {
    el.scrollIntoView({ behavior: 'auto', block: 'start' });
    return;
  }
  window.scrollTo({ top: 0, behavior: 'auto' });
}
